module.exports = __webpack_public_path__ + "static/img/JAVIER_SIERRA.6b866c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/JAVIER_SIERRA.jpg
// module id = XzHR
// module chunks = 1